<mat-divider *ngIf="!disableDividers"></mat-divider>
<div matSubheader [ngClass]="{'disable-background': disableBackground}">
    <ng-content>

    </ng-content>
</div>
<mat-divider *ngIf="!disableDividers"></mat-divider>
